import { render } from "./InstallButton.vue?vue&type=template&id=62cfea2a&scoped=true"
import script from "./InstallButton.vue?vue&type=script&lang=js"
export * from "./InstallButton.vue?vue&type=script&lang=js"

import "./InstallButton.vue?vue&type=style&index=0&id=62cfea2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cfea2a"]])

export default __exports__